export default __webpack_public_path__ + "static/icon-7-4-83f7f43514a34e0956059ffdb88361af.png";